export default __webpack_public_path__ + "80c55aa2326051f0e22917abd2a51b3d.png";